import { render } from "./OtifComponentes.vue?vue&type=template&id=7a0bfe8f&scoped=true"
import script from "./OtifComponentes.vue?vue&type=script&lang=js"
export * from "./OtifComponentes.vue?vue&type=script&lang=js"

import "./OtifComponentes.vue?vue&type=style&index=0&id=7a0bfe8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0bfe8f"]])

export default __exports__